import { render } from "./MorphToField.vue?vue&type=template&id=f87040ea"
import script from "./MorphToField.vue?vue&type=script&lang=js"
export * from "./MorphToField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MorphToField.vue"]])

export default __exports__